import './ClasificacionPage.scss';
import React, { useEffect, useState }  from 'react';
import { getFantasyParticipantes, getFantasyConfig, getUserTeam } from '../../firebase-service/firebaseService.js'
import LaurelImg from '../../assets/img/laurel.png';
import PlayerCard from '../../component/PlayerCard.js';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import cara from "../../assets/img/cara-default.png";
import PlayerCardImage from '../../component/PlayerCardImage.js';

export function ClasificacionPage() {

    const [participantes, setParticipantes] = useState([]);
    const [jornada, setJornada] = useState(0);
    const [cambiosAbiertos, setCambiosAbiertos] = useState(true);
    const [filter, setFilter] = useState(-1);
    const [jornadaSeleccionada, setJornadaSeleccionada] = useState(0);


    const [optionsDropDown, setOptionsDropDown] = useState([]);

    //Modal
    const [openModal, setOpenModal] = useState(false);
    const [selectedParticipante, setSelectedParticipante] = useState(null);
    const [equipoAMostrar, setEquipoAMostrar] = useState([]);
    const [configAMostrar, setConfigAMostrar] = useState([]);

    useEffect(() => {
        esperarPorParticipantes()
        esperarPorJornada()
    }, []);

    //Jornadas aplazadas ejemplo 30
    const participantesFiltrados = filter == -1 || filter == 29
    ? participantes.sort((a,b) => b.puntosTotal - a.puntosTotal)
    : participantes.sort((a,b) => filter >= 30 ? b.puntosJornada[filter-1] - a.puntosJornada[filter-1] : b.puntosJornada[filter] - a.puntosJornada[filter]);

    const getPuntosJornada = (participante, campo) => {
        if (filter === 29) return "-";
        const indiceJornada = filter >= 30 ? filter - 1 : filter;
        return participante[campo]?.[indiceJornada] ?? "-";
    };

    const esperarPorParticipantes = async () => {
        getFantasyParticipantes(resp => {
            if (resp.length > 0) { 
                resp = resp.sort((a,b) => b.puntosTotal - a.puntosTotal)
                setParticipantes(resp)
            }
            if (resp.length === 0) { setParticipantes([]) }
        }, (resp, err) => { console.error(resp, err) })
    };

    const openParticipanteInfo = (participante) =>{
        console.log(participante)
        if(!cambiosAbiertos){
            cargarJugadoresUsuario(participante, jornada)
        } else {
            setSelectedParticipante(participante)
        }
        setOpenModal(true)
        setJornadaSeleccionada(jornada)
    }

    const cargarJugadoresUsuario = async (selectedUser, jornada) => {
        getUserTeam(selectedUser.id, jornada, resp => {
            if (resp.length > 1) { 
                var userTemp = selectedUser
                setEquipoAMostrar(resp)
                setConfigAMostrar(resp[0])
                setSelectedParticipante(userTemp)
            }
            if (resp.length <= 1) { 
                setEquipoAMostrar([])
                setConfigAMostrar([])
                setSelectedParticipante(selectedUser)
             }
        }, (resp, err) => { 
            console.error(resp, err)
        })
    };

    const esperarPorJornada = async () => {
        getFantasyConfig(resp => {
            if (resp.length !== null) { 
                setJornada(resp.nJornada)
                setCambiosAbiertos(resp.cambiosAbiertos)
                configDropDown(resp.nJornada)
            }
            if (resp.length === null) { setJornada(0); setCambiosAbiertos(resp.cambiosAbiertos); }
        }, (resp, err) => { console.error(resp, err) })
    };

    const configDropDown = (jornada) =>{
        var options = []
        options.push({value: -1 , label: "General "})
        for(var i = 0; i< jornada; i++){
            options.push({value: i , label: "Jornada "+ (i +1)})
        }
        setOptionsDropDown(options)
    }

    const cuadriculaPuntos = (participante) => {
        var rows = []
        for(var i = 0; i< 22; i++){
            rows.push (
                <div key={i} className={participante.posicionesJornadas[i]== null ? 'not-played' : participante.posicionesJornadas[i]== 1 ? "first-jornada" : participante.posicionesJornadas[i]== 2 ? "second-jornada" : participante.posicionesJornadas[i]== 3 ? "third-jornada" : participante.posicionesJornadas[i]== -1 ? "castigo-jornada" : 'neutro-jornada'}>
                    {participante.puntosJornada[i]!= null ? participante.puntosJornada[i] : "j"+(i+1)}
                </div>
            )
        }
        return rows
    }

    const getJornadasConPuntos = () =>{
        let content = [];
        for (let i = 0; i < jornada; i++) {
            //Jornadas aplazadas ejemplo 30
            if (i <= 28){
                 content.push(
                     <div className={jornadaSeleccionada - 1 == i ? "jornada-circulo-selected" : "jornada-circulo"} onClick={() => seleccionarJornada(i + 1)}>
                        <div className='jornada-numero'>{"J"+(i + 1)}</div>
                        <div className='jornada-puntos'>{selectedParticipante.puntosJornada[i] != null ? selectedParticipante.puntosJornada[i] : "-"}</div>
                    </div>);
            } else if (i == 29){
                content.push(
                    <div className={jornadaSeleccionada - 1 == i ? "jornada-circulo-selected" : "jornada-circulo"} onClick={() => seleccionarJornada(i + 1)}>
                        <div className='jornada-numero'>{"J"+(i + 1)}</div>
                        <div className='jornada-puntos'>{"-"}</div>
                    </div>);
            } else if (i >= 30){
                content.push(
                     <div className={jornadaSeleccionada - 1 == i ? "jornada-circulo-selected" : "jornada-circulo"} onClick={() => seleccionarJornada(i + 1)}>
                        <div className='jornada-numero'>{"J"+(i + 1)}</div>
                        <div className='jornada-puntos'>{selectedParticipante.puntosJornada[i-1] != null ? selectedParticipante.puntosJornada[i-1] : "-"}</div>
                    </div>);
            } else {
               
            }
        }
        return content;
    }

    const seleccionarJornada = (nJornada) =>{
        setJornadaSeleccionada(nJornada)
        cargarJugadoresUsuario(selectedParticipante,nJornada)
    }

    return (
        <main className="clasificacion-container">
            <div className='clasificacion-filtro-container'>
                <div className='clasificacion-general-text'>
                    Clasificación
                </div>
                <div className={'clasificacion-jornada-container '}>
                    <div className='clasificacion-jornada-text'>
                    <Dropdown options={optionsDropDown} onChange={(arg)=>setFilter(arg.value)} value={optionsDropDown[0]} placeholder="Jornada" />
                    </div>
                </div>
            </div>
            <div className='participantes-container'>
                <div className='participante-container participantes-header'>
                    <div className='participante-posicion'></div>
                    <div className='participante-image'></div>
                    <div className='participante-nombre'></div>
                    <div className='participante-puntos-ultima-jornada'>
                        {filter !== -1 ? "Puntos equipo" : ""}
                    </div>
                    <div className='participante-puntos'>
                        {filter !== -1 ? "Puntos jornada" : "Total"}
                    </div>
                </div>
                {participantesFiltrados.map((participante, index) => (
                    <div key={participante.id} className={'participante-container ' + (index==0 ? "first" : index==1 ? "second" : index==2 ? "third" : index==participantes.length-1 ? "last" : "")} onClick={()=>openParticipanteInfo(participante)}>
                        <div className='participante-posicion'>
                            {(index+1)+"º"}
                           {index<3 && <img src={LaurelImg} alt="laurel" className="laurel-position"/>}
                        </div>
                         <div className="participante-image">
                            <img src={participante.foto ? participante.foto : cara} alt="Cara" className="player-face"/>
                        </div>
                        <div className='participante-nombre'>
                            {participante.nombre}
                        </div>
                        <div className='participante-puntos-ultima-jornada '>
                            {filter === -1 ? "" : getPuntosJornada(participante, "puntosEquipo")}
                        </div>
                        <div className='participante-puntos'>
                            {filter === -1 ? participante.puntosTotal : getPuntosJornada(participante, "puntosJornada")}
                        </div>
                    </div>
                ))}
            </div>
            <div className='best-team-container'>
                
            </div>
            {openModal &&
                <div className='modal-container'>
                    {selectedParticipante != null &&
                        <>
                            <div className='user-name-text'>
                                {selectedParticipante.nombre}
                            </div>
                            <div className='close-modal' onClick={()=>{
                                setOpenModal(false)
                                setEquipoAMostrar([])
                                setConfigAMostrar([])
                                setSelectedParticipante(null)
                                setJornadaSeleccionada(0)
                            }}>
                                X
                            </div>
                            <div className='data-container-modal'>
                                <div className='data-text-modal'>
                                    Puntos Totales : {selectedParticipante.puntosTotal}
                                </div>
                                {/*<div className='data-text-modal'>
                                    Puntos por jornadas:
                                </div>
                                <div className='points-container-data'>
                                    { cuadriculaPuntos(selectedParticipante) }
                                </div>*/}
                            </div>
                            <div className='jornadas-container'>
                                {getJornadasConPuntos()}
                            </div>
                            
                            {(jornadaSeleccionada < jornada || !cambiosAbiertos) &&
                                <>
                                    <div className='team-container-image'>
                                        {equipoAMostrar && equipoAMostrar.map((jugador, index) => {
                                            if(index != 0){
                                                return (
                                                    <div className={"player-card"}>
                                                        <PlayerCardImage key={index} config={configAMostrar} index={index} jugador={jugador} updateSelections={()=>{}} longPressActive={false} openDetails={()=>{}} jornadaSeleccionada={jornadaSeleccionada} jornadaActual={jornada}/>
                                                    </div>
                                                )
                                            }
                                        })}
                                        {equipoAMostrar.length == 0 &&  
                                            <div >
                                                Sin equipo esta jornada
                                            </div>
                                        }
                                    </div>
                                </>
                            }
                        </>
                    }
                </div>
            }
        </main>
    );
}